export const ACCESS_TOKEN = 'LyL3dRdeGQoR4zFYs8bYI9Rh9rQqE3OXXSQNzHO8jSU';
export const WEBAPP_BASE_URL = 'https://test13.11sight.com';
export const PROSODY_BASE_URL = 'https://room-test8.11sight.com/';
export const LOGIN_URL = `${WEBAPP_BASE_URL}/oauth/authorize?client_id=jAU8S3I_oRFN4BjeRlNsLxuvstS_31kRWBGoG0juJBY&redirect_uri=https%3A%2F%2Flocalhost%3A8080&response_type=code&scope=vmeet+user_details`;
export const SSO_FRAME_URL = `${WEBAPP_BASE_URL}/oauth/get_token`;
export const FRAME_URL = `${WEBAPP_BASE_URL}/oauth/get_token`;
export const LOGOUT_URL = `${WEBAPP_BASE_URL}/oauth/sign_out`;
export const BASE_URL = 'https://test13.11sight.com/';
export const AUTHORIZED_ORGANISATIONS = [1, 2];
export const VCALL_CALL_URL = 'https://11to.me';
export const SALE_TEAM_TR = `${VCALL_CALL_URL}/cvbtuyq`;
export const SALE_TEAM_EN = `${VCALL_CALL_URL}/cosnbcp`;
export const TEST_SERVER_AUTH = 'Basic YzR5OjREM3N0aW5H';
export const NODE_ENV = 'dev';
